import React, { useState } from 'react';
import { Bar } from 'react-chartjs-2';

interface PerformanceRecord {
  c2D: string;
  c2J: string;
  c2S: string;
  c26: number;
}

interface Props {
  records: PerformanceRecord[];
  colors: string[];
}

const C2DrilldownBarChart: React.FC<Props> = ({ records, colors }) => {
  const [level, setLevel] = useState<'c2D' | 'c2J' | 'c2S'>('c2D');
  const [parent, setParent] = useState<string | undefined>(undefined);

  let labels: string[] = [];
  let values: number[] = [];
  let title = '2차 대분류별 매출';

  if (level === 'c2D') {
    const map: Record<string, number> = {};
    records.forEach(rec => {
      if (rec.c2D) map[rec.c2D] = (map[rec.c2D] || 0) + rec.c26;
    });
    labels = Object.keys(map);
    values = Object.values(map);
    title = '2차 대분류별 매출';
  } else if (level === 'c2J' && parent) {
    const map: Record<string, number> = {};
    records.filter(rec => rec.c2D === parent).forEach(rec => {
      if (rec.c2J) map[rec.c2J] = (map[rec.c2J] || 0) + rec.c26;
    });
    labels = Object.keys(map);
    values = Object.values(map);
    title = `2차 중분류별 매출 - ${parent}`;
  } else if (level === 'c2S' && parent) {
    const map: Record<string, number> = {};
    records.filter(rec => rec.c2J === parent).forEach(rec => {
      if (rec.c2S) map[rec.c2S] = (map[rec.c2S] || 0) + rec.c26;
    });
    labels = Object.keys(map);
    values = Object.values(map);
    title = `2차 소분류별 매출 - ${parent}`;
  }

  const handleBarClick = (evt: any, elements: any[]) => {
    if (!elements || elements.length === 0) return;
    const idx = elements[0].index;
    if (level === 'c2D') {
      setLevel('c2J');
      setParent(labels[idx]);
    } else if (level === 'c2J') {
      setLevel('c2S');
      setParent(labels[idx]);
    }
  };

  const handleBack = () => {
    if (level === 'c2S' && parent) {
      const parentJ = records.find(rec => rec.c2S === parent)?.c2J;
      setLevel('c2J');
      setParent(parentJ);
    } else if (level === 'c2J') {
      setLevel('c2D');
      setParent(undefined);
    }
  };

  return (
    <div className="drilldown-box">
      <h2>
        {title}
        {level !== 'c2D' && (
          <button onClick={handleBack}>◀</button>
        )}
      </h2>
      <div className="chart bar-chart">
        <Bar
          data={{
            labels,
            datasets: [
              {
                label: '매출액',
                data: values,
                backgroundColor: labels.map((_, i) => colors[i % colors.length]),
              },
            ],
          }}
          options={{
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: { display: false },
              title: { display: false },
              tooltip: {
                callbacks: {
                  label: function(context) {
                    const value = context.parsed.y;
                    return `매출액: ${value.toLocaleString()}원`;
                  }
                }
              }
            },
            onClick: handleBarClick,
            scales: {
              y: {
                ticks: {
                  callback: function(value) {
                    return value.toLocaleString();
                  }
                }
              }
            }
          }}
          height={300}
        />
      </div>
    </div>
  );
};

export default C2DrilldownBarChart; 